export default __webpack_public_path__ + "de8dfc3361013b1bbc3094297f3efd0a.png";